import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Formats a number with dot separators for thousands
 * e.g., 10000 -> "10.000", 1000000 -> "1.000.000"
 */
export function formatNumberWithDots(value: number | string | null | undefined): string {
  if (value === null || value === undefined) return "0";
  const num = typeof value === "string" ? parseInt(value, 10) : value;
  if (isNaN(num)) return "0";
  return num.toLocaleString("tr-TR");
}

/**
 * Returns responsive font size class based on digit count
 * Used for stats boxes to prevent layout breaking with large numbers
 * @param value - The number to check
 * @param baseSize - Base font size for 4 or fewer digits (default: 40 for large boxes, 32 for small boxes)
 */
export function getResponsiveFontSize(value: number | string | null | undefined, baseSize: 40 | 32 = 40): string {
  const formatted = formatNumberWithDots(value);
  // Count only digits (excluding dots)
  const digitCount = formatted.replace(/\./g, '').length;
  
  if (baseSize === 40) {
    // For large stats boxes (Toplam Hak Sahibi, Toplam Konut Sayısı)
    if (digitCount <= 4) return 'text-[40px]';
    if (digitCount === 5) return 'text-[34px]';
    if (digitCount === 6) return 'text-[28px]';
    return 'text-[24px]'; // 7+ digits
  } else {
    // For smaller stats boxes (Asil Sayısı, Kalan Hak Sahibi)
    if (digitCount <= 4) return 'text-[32px]';
    if (digitCount === 5) return 'text-[28px]';
    if (digitCount === 6) return 'text-[24px]';
    return 'text-[20px]'; // 7+ digits
  }
}
